"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils"); // TODO: change to utils
function matchesState(parentStateId, childStateId) {
    var parentStateValue = utils_1.toTrie(parentStateId);
    var childStateValue = utils_1.toTrie(childStateId);
    if (typeof childStateValue === 'string') {
        if (typeof parentStateValue === 'string') {
            return childStateValue === parentStateValue;
        }
        return childStateValue in parentStateValue;
    }
    if (typeof parentStateValue === 'string') {
        return parentStateValue in childStateValue;
    }
    return Object.keys(parentStateValue).every(function (key) {
        if (!(key in childStateValue)) {
            return false;
        }
        return matchesState(parentStateValue[key], childStateValue[key]);
    });
}
exports.default = matchesState;



//////////////////
// WEBPACK FOOTER
// ./~/xstate/lib/matchesState.js
// module id = 713
// module chunks = 168707334958949